// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-menu input {
    width: 100%;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    letter-spacing: 0.025em;
    --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.add-menu button {
    height: 3rem;
    border-radius: 0px;
}
.add-menu .btn {
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
    font-weight: 100;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    transition-property: all;
    transition-delay: 100ms;
    transition-duration: 100ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.add-menu .btn:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
    --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-drop-shadow: drop-shadow(0 0 #0000);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.add-menu form {
    margin-left: 0px;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    padding: 0px;
}

.menu_nest .pagedetails__row--two .pagedetails__col--two {
    grid-column: span 3 / span 3;
    height: fit-content;
    overflow: hidden;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.menu_nest .pagedetails__row--two .pagedetails__col--one .pagedetails__col--one-wrapper {
    height: fit-content;
    width: 100%;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.editOptions.indivisual_widget {
    z-index: 50;
    margin-bottom: 1rem;
    max-width: 24rem;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.editOptions.indivisual_widget form {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1rem;
    padding: 1rem;
}

.editOptions.indivisual_widget .name {
    border-bottom-width: 1px;
    padding-bottom: 0.75rem;
    text-align: center;
    text-transform: capitalize;
    letter-spacing: 0.05em;
}

.dissabledSliderForm__btn {
    height: 3rem;
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
`, "",{"version":3,"sources":["webpack://./src/pages/MenuDetails/menuDetails.css"],"names":[],"mappings":"AACI;IAAA,WAAsF;IAAtF,uBAAsF;IAAtF,kBAAsF;IAAtF,4DAAsF;IAAtF,mBAAsF;IAAtF,sBAAsF;IAAtF,qBAAsF;IAAtF,sBAAsF;IAAtF,uBAAsF;IAAtF,gDAAsF;IAAtF,6DAAsF;IAAtF,uGAAsF;IAAtF,8BAAsF;IAAtF;AAAsF;AAGtF;IAAA,YAAwB;IAAxB;AAAwB;AAGxB;IAAA,WAA4M;IAA5M,kBAA4M;IAA5M,0DAA4M;IAA5M,gBAA4M;IAA5M,yBAA4M;IAA5M,uBAA4M;IAA5M,oBAA4M;IAA5M,mDAA4M;IAA5M,0EAA4M;IAA5M,8FAA4M;IAA5M,uGAA4M;IAA5M,mGAA4M;IAA5M,iLAA4M;IAA5M,wBAA4M;IAA5M,uBAA4M;IAA5M,0BAA4M;IAA5M;AAA4M;AAA5M;IAAA,kBAA4M;IAA5M,0DAA4M;IAA5M,gDAA4M;IAA5M,6DAA4M;IAA5M,uGAA4M;IAA5M,wCAA4M;IAA5M;AAA4M;AAG5M;IAAA,gBAA6B;IAA7B,iBAA6B;IAA7B,aAA6B;IAA7B,sBAA6B;IAA7B;AAA6B;;AAI7B;IAAA,4BAA4E;IAA5E,mBAA4E;IAA5E,gBAA4E;IAA5E,uBAA4E;IAA5E,kBAA4E;IAA5E,4DAA4E;IAA5E,aAA4E;IAA5E,+EAA4E;IAA5E,mGAA4E;IAA5E;AAA4E;;AAI5E;IAAA,mBAAqD;IAArD,WAAqD;IAArD,uBAAqD;IAArD,kBAAqD;IAArD,4DAAqD;IAArD,aAAqD;IAArD,+EAAqD;IAArD,mGAAqD;IAArD;AAAqD;;AAGzD,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;;AAGI;IAAA,WAA4C;IAA5C,mBAA4C;IAA5C,gBAA4C;IAA5C,uBAA4C;IAA5C,kBAA4C;IAA5C;AAA4C;;AAK5C;IAAA,aAAiC;IAAjC,gDAAiC;IAAjC,SAAiC;IAAjC;AAAiC;;AAIjC;IAAA,wBAA0D;IAA1D,uBAA0D;IAA1D,kBAA0D;IAA1D,0BAA0D;IAA1D;AAA0D;;AAI1D;IAAA,YAA2E;IAA3E,WAA2E;IAA3E,kBAA2E;IAA3E,4DAA2E;IAA3E,yBAA2E;IAA3E,uBAA2E;IAA3E,oBAA2E;IAA3E,mDAA2E;IAA3E,+EAA2E;IAA3E,mGAA2E;IAA3E;AAA2E","sourcesContent":[".add-menu input {\n    @apply w-full outline-none py-2 px-3 shadow-inner bg-gray-100 rounded-md tracking-wide;\n}\n.add-menu button {\n    @apply rounded-none h-12;\n}\n.add-menu .btn {\n    @apply w-full bg-green-500 font-thin tracking-wide uppercase shadow text-white transition-all ease-in-out duration-100 delay-100 hover:bg-green-500 drop-shadow-md hover:drop-shadow-none hover:shadow-inner;\n}\n.add-menu form {\n    @apply flex flex-col mx-0 p-0;\n}\n\n.menu_nest .pagedetails__row--two .pagedetails__col--two {\n    @apply col-span-3 bg-gray-300 overflow-hidden rounded-md shadow-lg p-4 h-fit;\n}\n\n.menu_nest .pagedetails__row--two .pagedetails__col--one .pagedetails__col--one-wrapper{\n    @apply bg-white rounded-md p-4 h-fit shadow-lg w-full;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.no-scrollbar::-webkit-scrollbar {\n    display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.no-scrollbar {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n\n.editOptions.indivisual_widget {\n    @apply bg-white z-50 mb-4 rounded-md max-w-sm\n\n}\n\n.editOptions.indivisual_widget form {\n    @apply grid grid-cols-1 gap-4 p-4;\n}\n\n.editOptions.indivisual_widget .name {\n    @apply text-center capitalize tracking-wider border-b pb-3;\n}\n\n.dissabledSliderForm__btn {\n    @apply w-full bg-gray-500 text-white h-12 uppercase tracking-wide shadow-lg;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
